/** @format */
import { css } from 'styled-components';

export const styles = css`
    padding: var(--layout-spacing-24) 0 var(--layout-spacing-12) 0;

    .search-filter-menu__heading {
        margin-bottom: var(--layout-spacing-4);
    }

    .search-filter-menu__extra-content {
        display: flex;
        align-items: center;
        gap: var(--layout-spacing-24);
    }
`;
